import { Icon, Text } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";
import classNames from "classnames";
import { T } from "src/i18n";

import { sortAtom } from "../../../store/atoms";
import css from "./ReleaseDateHeader.module.scss";
import { getReleaseSortToggle } from "./ReleaseDateHeader.utils";

export const ReleaseDateHeader = () => {
  const [sort, setSort] = useAtom(sortAtom);
  const { icon, isActive, nextSort } = getReleaseSortToggle(sort?.type);

  return (
    <button
      type="button"
      className={css.header}
      onClick={() => setSort(nextSort)}
    >
      <Text variant="subheader-1">
        <T
          keyName="product_page.product_list.table.header.releaseDate"
          defaultValue="Дата релиза"
        />
      </Text>
      <Icon
        size={14}
        data={icon}
        className={classNames(css.icon, isActive && css.iconActive)}
      />
    </button>
  );
};
